import { TabContentSection, TabContentSectionTitle } from '../../dev-tools.styles';

export const LocationTab = () => {
  return (
    <>
      <TabContentSection>
        <TabContentSectionTitle>Location</TabContentSectionTitle>
      </TabContentSection>
    </>
  );
};
